import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import Paginate from "components/footers/paginate";
import { useDispatch, useSelector } from "react-redux";
import { getListMethod } from "redux/SuratReducers/ListSuratMasuk/ListSuratAction";
import {
  decrement,
  increment,
  setFirstPage,
  setLastPage,
} from "utils/pagination";
import Loading from "components/body/Loading";

const Content = () => {
  const dispatch = useDispatch();
  const { GeneralReducers, ListSuratReducers } = useSelector((state) => state);
  const { loading } = GeneralReducers;
  const { items, meta } = ListSuratReducers.listSuratBatal;
  const getList = (current_page = 1) => {
    dispatch(getListMethod("reject/mail", "listSuratBatal", current_page));
  };
  return (
    <Fragment>
      <div className="content-title">
      </div>
      <div className="content-body">
        <Loading isLoading={loading} />
        <table className="table table-striped table-list">
          <thead>
            <tr>
              <td>Nomor Surat</td>
              <td>Tanggal Dibuat</td>
              <td>Dari</td>
              <td>Hal</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody>
            {items &&
              items.map((list, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <Link to={`/surat-keluar/surat-batal/detail/${list.id}`}>
                        01/SK/MKS/III/2020
                      </Link>
                    </td>
                    <td>20/05/2020</td>
                    <td>Kadis Pendidikan</td>
                    <td>Rekomendasi Kegiatan Bimtek Aplikasi Kinerja</td>
                    <td>
                      <span className="badge badge-danger">Reject</span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {meta && (
        <Paginate
          meta={meta}
          increment={() => increment(meta.current_page, getList)}
          decrement={() => decrement(meta.current_page, getList)}
          setLastPage={() => setLastPage(meta.last_page, getList)}
          setFirstPage={() => setFirstPage(meta.from, getList)}
        />
      )}
    </Fragment>
  );
};

export default Content;
